/**
 * "Start guided demo tour" - offered only to a demo tenant (tour-policy.ts).
 *
 * The tour it opens narrates a fictional showcase tenant, so a customer's own
 * install must not offer it. Renders nothing for a customer tenant, while
 * entitlements are loading, when they fail to load, and when no one is signed
 * in (the tenant is unknown, so it is not a demo tenant).
 */
import { Link } from '@tanstack/react-router';
import { Sparkles } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useEntitlements } from '@/lib/use-entitlements';

import { isDemoTenant } from './tour-policy';

export function DemoTourButton({ primary }: { primary: boolean }): JSX.Element | null {
  const { entitlements } = useEntitlements();
  if (!isDemoTenant(entitlements)) return null;
  const link = (
    <Link to="/" search={{ demo: 'tour' } as Record<string, unknown>}>
      <Sparkles className="h-4 w-4" /> Start guided demo tour
    </Link>
  );
  return primary ? (
    <Button size="lg" asChild className="bg-gradient-to-r from-primary to-accent shadow-lg">
      {link}
    </Button>
  ) : (
    <Button size="lg" variant="glass" asChild className="border-primary/40 hover:border-primary">
      {link}
    </Button>
  );
}
